type LexicalTextNode = {
  detail: number;
  format: number;
  mode: string;
  style: string;
  text: string;
  type: 'text';
  version: number;
};

type LexicalNode = LexicalTextNode | LexicalElementNode;

type LexicalElementNode = {
  children: LexicalNode[];
  direction: string;
  format: string;
  indent: number;
  type: string;
  version: number;
  tag?: string;
  listType?: 'bullet' | 'number';
  start?: number;
  value?: number;
};

const createTextNode = (text: string): LexicalTextNode => ({
  detail: 0,
  format: 0,
  mode: 'normal',
  style: '',
  text,
  type: 'text',
  version: 1,
});

export const createParagraphNode = (text: string): LexicalElementNode => ({
  children: [createTextNode(text)],
  direction: 'ltr',
  format: '',
  indent: 0,
  type: 'paragraph',
  version: 1,
});

export const createHeadingNode = (text: string, tag: 'h1' | 'h2' | 'h3' | 'h4' = 'h3'):
  LexicalElementNode => ({
  children: [createTextNode(text)],
  direction: 'ltr',
  format: '',
  indent: 0,
  type: 'heading',
  version: 1,
  tag,
});

export const createListNode = (items: string[]): LexicalElementNode => ({
  children: items.map((item, index) => ({
    children: [createTextNode(item)],
    direction: 'ltr',
    format: '',
    indent: 0,
    type: 'listitem',
    version: 1,
    value: index + 1,
  })),
  direction: 'ltr',
  format: '',
  indent: 0,
  type: 'list',
  version: 1,
  listType: 'bullet',
  start: 1,
  tag: 'ul',
});

export const buildLexicalDocument = (nodes: LexicalElementNode[]): string =>
  JSON.stringify({
    root: {
      children: nodes,
      direction: 'ltr',
      format: '',
      indent: 0,
      type: 'root',
      version: 1,
    },
  });
